import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;

  .titlePage {
    display: flex;
    margin: 2rem 0 0 9rem;
    h1 {
      max-width: 1056px;
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 600;
    }
  }

  @media (max-width: 1000px) {
    h1 {
      margin: 2rem 0 0 4rem;
    }
  }

  @media (max-width: 800px) {
    padding: 0 1rem;
    h1 {
      margin: 2rem 0 0 2rem;
    }
  }

  @media (max-width: 370px) {
    h1 {
      margin: 1rem 0 0 0.5rem;
    }
  }
`;

export const Body = styled.div`
  width: 100%;

  h2 {
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 600;
  }

  .contentGrid {
    display: flex;
    justify-content: center;
  }

  .addressGrid {
    display: flex;
    gap: 1rem;
  }

  .fieldError {
    padding-top: 0.2rem;
    color: red;
    display: flex;
    align-items: center;
    font-size: 1rem;

    svg {
      margin-right: 2px;
      font-size: 1rem;
      padding-bottom: 0.1rem;
      fill: red;
    }
  }
  .containerServices {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.background_white};
    padding: 2rem;
    margin: 4rem 0 0 0;
    display: flex;
    justify-content: center;

    .containerContent {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 2.5rem;
      max-width: 652px;

      .containerServiceName {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        div {
          width: 100%;

          h2 {
            margin-bottom: 1rem;
          }
        }

        &.containerFormSelects {
          gap: 2.5rem;
        }
      }

      .containerVirtualAudience {
        display: flex;
        h3 {
          color: ${({ theme }) => theme.colors.primary};
          margin-top: 0.4rem;
          white-space: nowrap;
          margin-right: 1.5rem;
        }
        .containerInput {
          width: 4rem;
          min-width: 4rem;
          max-width: 4rem;
        }
      }
      .containerArea {
        div {
          width: 100%;
        }
      }
      .containerDistrict {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .containerDistrictBase {
          display: flex;
          margin-bottom: 1rem;
        }
        .containerDistrictState {
          font-size: 1rem;
          line-height: 1rem;
          width: 10rem;
          padding-right: 1rem;
        }

        .containerDistrictName {
          width: calc(100% - 11rem);
        }
      }

      .containerIntegratedProtocol {
        display: flex;
        align-items: center;
        h3 {
          color: ${({ theme }) => theme.colors.primary};
          margin-top: 0.4rem;
          white-space: nowrap;
          margin-right: 1.5rem;
        }
        h4 {
          color: ${({ theme }) => theme.colors.primary};
          padding-right: 1rem;
          white-space: nowrap;
        }
        .controllerYesNo {
          width: 4rem;
        }
      }
      .containerPartsName {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        width: 100%;
        max-height: 8rem;
        overflow-y: auto;
        padding: 1rem 0.5rem;
        margin: 1rem 0;
        border-radius: 1rem;
      }

      @media (max-width: 800px) {
        .containerPartsName {
          padding: 1rem 0;
        }
      }
    }

    .localizationMap {
      width: 100%;
      margin-top: 1rem;
      background-color: ${({ theme }) => theme.colors.background};

      .map {
        min-height: 300px;
      }
    }
  }

  .containerDataAddress {
    .title {
      display: flex;
      gap: 0.3rem;

      svg {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.text_gray};
      }
    }

    input:nth-child(1) {
      margin-bottom: 0.5rem;
    }

    .street-number {
      display: flex;
      gap: 1rem;

      .number {
        width: 20%;
      }
      .street {
        width: 80%;
      }
    }

    .city-state {
      display: flex;
      gap: 1rem;

      .city {
        width: 60%;
      }
      .state {
        color: ${({ theme }) => theme.colors.text_gray};
        display: flex;
        flex-direction: column;
        justify-content: end;
        width: 40%;
        font-size: 1rem;
        line-height: 1rem;
      }
    }
  }

  .noteContainer {
    width: 100%;
    //position: relative;
    margin: 0rem 0 1rem 0;

    .note {
      display: flex;
      justify-content: center;
      min-height: 4.5rem;
      max-height: 4.5rem;
      padding: 1rem;
      width: -webkit-fill-available;
      border-radius: 1rem;
      font-size: 1.2rem;
      overflow-y: auto;
      resize: none;
      margin: 0.5rem 0;
      border-color: ${({ theme }) => theme.colors.primary};
    }

    span {
      width: 40%;
    }
  }

  .attachmentContainer {
    .attachmentDescriptions {
      span {
        font-style: italic;
      }
    }

    .containerDropZone {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .attachments-drop-zone {
        margin: 1rem 0;
        width: 80%;
      }

      .attachment-list {
        width: 100%;
        display: grid;
        height: 100%;
        grid-template-columns: 1fr 1fr;
        max-height: 7rem;
        gap: 0.6rem;
        margin-top: 1rem;
        overflow-y: auto;
      }
    }
  }

  .suggestionValue {
    margin-top: 1.5rem;

    .inputSuggestionValue {
      .MuiOutlinedInput-root {
        text-align: center;
        font-size: 1.3rem;

        fieldset {
          border: none;
          border: 2px ${({ theme }) => theme.colors.primary} solid;
          border-radius: 0.8rem;

          font-family: 'Futura PT';
          font-weight: 300;
        }

        :hover {
          fieldset {
            padding: 0 0.5rem;
            border: 2px ${({ theme }) => theme.colors.primary} solid;
          }
        }
      }
    }

    .fieldError {
      padding: 0;
      color: red;
      display: flex;
      align-items: center;
      font-size: 1rem;
      flex-wrap: nowrap;

      svg {
        margin-right: 2px;
        font-size: 1rem;
        padding-bottom: 0.1rem;
        color: ${({ theme }) => theme.colors.error};
      }
    }
  }

  .containerDataSolicitation {
    display: flex;
    margin: 1rem 0;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.background_white};
    border-radius: 1rem;

    .contentDate {
      display: flex;
      align-items: center;
      margin-top: 0.5rem;
      gap: 3rem;

      .MuiOutlinedInput-root {
        text-align: center;

        fieldset {
          border: none;
          border-radius: 0;
          border-bottom: 2px ${({ theme }) => theme.colors.primary} solid;
        }

        :hover {
          fieldset {
            border-bottom: 2px black solid;
          }
        }
      }

      .MuiInputBase-input {
        padding: 0.3rem 0 0 0;
        font-family: 'Futura PT';
        font-weight: 350;
        font-size: 1.2rem;
      }

      .time {
        width: 40%;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1rem;

        .dropdownTime {
          width: 14%;
        }
      }

      h3 {
        font-size: 22px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  .containerService {
    width: 100%;

    svg {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }

  .containerButton {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 440px) {
    .containerDataSolicitation {
      gap: 1em;

      .contentDate {
        flex-direction: column;
        .time {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  @media (max-width: 1000px) {
    .containerServices {
      margin: 2rem 0 0 0;
    }
  }

  @media (max-width: 800px) {
    .containerButton {
      display: flex;
      justify-content: center;
    }
    .containerServices {
      margin: 0rem 0 0 0;
    }
  }

  @media (max-width: 370px) {
    .attachmentContainer .containerDropZone .attachments-drop-zone {
      width: 100%;
    }

    .containerServices {
      width: -webkit-fill-available;
      padding: 0.5rem;
    }
  }
`;

export const Providers = styled.div`
  width: 100%;

  .contentCardUserMap {
    display: grid;
    grid-template-columns: repeat(2, calc(100% / 2));
    gap: 1.5rem;
    margin-left: 2rem;
  }

  .footerContent {
    display: flex;
    justify-content: space-between;
    width: 95%;
    margin: 2rem 0;

    .generateContainer {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      align-items: center;

      h1 {
        color: ${({ theme }) => theme.colors.tertiary_500};
        font-weight: 500;
      }

      span {
        font-weight: 300;
      }
    }
  }
`;
